import contextActionTypes from 'src/modules/shared/context/actionTypes';
import { fetchCurrentUser, fetchPermissions, fetchUnreadMessagesCount, fetchUnreadNotificationsCount } from 'src/modules/shared/context/actions';
import Router from 'next/router';
import { getLangCookie } from 'src/utils/cookie';
import { setLocalStorageItem } from 'src/utils/localStorage';
import { init as initWebsockets } from 'src/modules/websockets/initWebsockets';
import { truncate } from 'underscore.string';

export default store => next => async action => {
  const result = next(action);
  switch (action.type) {
      case contextActionTypes.SIGN_UP_SUCCESS:
      case contextActionTypes.SOCIAL_SIGN_UP_SUCCESS:
        const isSinglePostPage = Router.route === '/community/singlePost';
        if (isSinglePostPage) {
          storeLastViewedPost(store);
        }
        const state = store.getState();
        await fetchUserData(store.dispatch, state.context.currentCommunity);
        break;
      case contextActionTypes.LOGIN_SUCCESS:
      case contextActionTypes.SOCIAL_LOGIN_SUCCESS:
        if (Router.route === '/') {
          window.location.reload();
          return;
        }
        await initData(store);
        break;
    default:
      break;
  }

  return result;
};

const storeLastViewedPost = (store) => {
  const { pages: { singlePost: { post } } } = store.getState();
  const LAST_VIEWED_POST_KEY = '__hu_last_post__';
  const lastPost = {
    postId: post.id,
    snippet: truncate(post.body, 80),
    authorAvatarImage: post.author.avatarMedium,
    title: post.title,
    link: post.postUrl,
  };
  setLocalStorageItem(LAST_VIEWED_POST_KEY, JSON.stringify(lastPost));
};

const initData = async (store) => {
  initWebsockets(store);
  const state = store.getState();
  const langCookie = getLangCookie();
  if (state.context.lang !== langCookie) {
    window.location.reload();
  } else {
    // reload current page to refresh page data
    await fetchUserData(store.dispatch, state.context.currentCommunity);
    Router.reload('/');
  }
};

const fetchUserData = async (dispatch, currentCommunity) => {
  await dispatch(fetchCurrentUser());
  const communityId = currentCommunity && currentCommunity.communityId;
  dispatch(fetchPermissions(communityId));
  dispatch(fetchUnreadMessagesCount());
  dispatch(fetchUnreadNotificationsCount());
};



// WEBPACK FOOTER //
// ./src/middleware/context.js